import*as e from"react";import{I as r}from"./index-7252bb8c.js";var t=function(t,l){return e.createElement(r,l,e.createElement("path",{fill:"currentColor",d:t,fillRule:"evenodd",clipRule:"evenodd"}))};export{t as c};
//# sourceMappingURL=createSvgIcon-2fb674e7.js.map
